import { createOpLoc, updateOpLoc } from "@/helpers/opLocHelper";
import { confirmWarningConfig } from "@/configuration/confirmConfigurations";

export default {
  props: ["editedItem", "isOwnedBySubPrincipal"],
  data: () => ({}),
  mounted() {},
  methods: {
    createOpLoc,
    updateOpLoc,
    async removeOplocMapping() {
      const confirm = await this.$confirm(
        "Möchten Sie die Verknüpfung wirklich entfernen? Achtung: Der Veranstalter/Veranstaltungsort wird nicht gelöscht, sondern nur die Verknüpfung zu diesem POI.",
        confirmWarningConfig
      );
      if (confirm) {
        const mappedOploc = await this.getMappedOploc();

        this.editedItem.events_module.oploc_id = "";
        this.editedItem.events_module.isOperator = false;
        this.editedItem.events_module.isLocation = false;

        mappedOploc.poi_id = "";
        await this.updateOpLoc(mappedOploc);

        this.$emit("save", false);
        await this.$store.dispatch("createSuccess", "Verknüpfung entfernt!");
      }
    },
    async createNewOploc() {
      if (!this.editedItem._id) {
        await this.$store.dispatch("createError", {
          text: "Bitte zuerst speichern!"
        });
        return;
      }
      const newOploc = await this.getMappedOploc();
      const createdOploc = await this.createOpLoc(newOploc);
      if (createdOploc?.data?._id) {
        await this.$store.dispatch("createSuccess", "Erfolgreich erstellt!");
        this.editedItem.events_module.oploc_id = createdOploc.data._id;
      }
      this.$emit("save", false);
    },
    async getMappedOploc() {
      const types = [];

      if (this.editedItem?.events_module?.isOperator) types.push("operator");
      if (this.editedItem?.events_module?.isLocation) types.push("location");

      if (!types?.length) {
        await this.$store.dispatch("createError", {
          text: "Bitte mindestens einen Typ auswählen!"
        });
        return;
      }

      const newOploc = {
        title: this.editedItem.title,
        principal_id: this.editedItem.principal,
        poi_id: this.editedItem._id,
        type: types,
        address: {
          ...this.editedItem.address,
          additional_address: this.editedItem?.address?.additionalAddress || "",
          phone: this.editedItem?.address?.phoneNumber || "",
          mobile: this.editedItem?.address?.mobileNumber || "",
          email: this.editedItem?.address?.eMail || ""
        }
      };
      if (this.editedItem.geo.lng && this.editedItem.geo.lat) {
        newOploc.geo = {
          type: "Point",
          coordinates: [this.editedItem.geo.lng, this.editedItem.geo.lat]
        };
      }

      if (this.editedItem.events_module?.oploc_id) {
        newOploc._id = this.editedItem.events_module.oploc_id;
      }

      return newOploc;
    },
    async openOploc() {
      await this.$emit("save", false);
      window.open(
        `/events/oplocs/${this.editedItem.events_module.oploc_id}`,
        "_blank"
      );
    }
  },
  computed: {
    selectedPrincipal() {
      return this.$store.state.selectedPrincipal;
    }
  }
};
